import type { ReactNode } from 'react';

import styles from './ContextRail.module.css';

interface ContextRailProps {
  children: ReactNode;
  /** Доступное имя колонки: что за контекст в ней стоит. */
  label: string;
}

/**
 * Правый контекстный сайдбар (DESIGN_SYSTEM §4.3).
 *
 * Содержимое задаёт экран через `useAppShell`; сама колонка — свойство
 * оболочки: она лишь ставит карточки экрана стопкой с шагом `--space-md`.
 * Карточку рисует экран — обычной карточкой дизайн-системы (§5.2: белая
 * поверхность, граница, `--radius-card`, `--shadow-card`), а не колонка:
 * обёртка колонки поверх карточек экрана дала бы карточку в карточке.
 *
 * На узких экранах колонка уезжает под контент отдельными карточками, а не
 * прячется: контекст (критерии, следующий шаг, сводка) нужен и на мобильном.
 */
export function ContextRail({ children, label }: ContextRailProps) {
  return (
    <aside className={styles.rail} aria-label={label}>
      {children}
    </aside>
  );
}
